module.exports = __webpack_public_path__ + "static/media/sreehari_s.70403493.jpg";